import {EntityTypeEnum} from '../enums/entity-type-enum';

export class UserEntity {
  Identifier_Code: string;
  Entities_Name: string;
  Entity_Type: EntityTypeEnum;

  constructor(Identifier_Code: string, Entities_Name: string, Entity_Type: EntityTypeEnum) {
    this.Identifier_Code = Identifier_Code;
    this.Entities_Name = Entities_Name;
    this.Entity_Type = Entity_Type;
  }
}
